import type { ApiResponse } from "@/types";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { api } from "../api/api";
import { QUERY_KEYS } from "./queryKeys";

export function getSecretsQueryOptions(projectId: string) {
  return queryOptions({
    queryKey: [QUERY_KEYS.SECRETS, projectId],
    queryFn: () => api.listSecrets(projectId),
  });
}

export function useListSecrets(projectId: string) {
  return useQuery<ApiResponse<{ secretKeys: string[] }>>({
    queryKey: [QUERY_KEYS.SECRETS, projectId],
    queryFn: () => api.listSecrets(projectId),
    enabled: !!projectId,
  });
}
